/**
 * Agent configure route (CLA-697).
 *
 * Eagerly registers the `/clawinstall/dashboard/agents/$agentId/configure` file
 * route and its `?section=` search validator; the page component and its
 * atom/RPC imports are deferred to `.lazy.tsx` so the Connect-panel chunk stays
 * out of the always-loaded `main` bundle (CLA-645).
 *
 * The section lives in the URL — exactly as the onboarding Connect stop's
 * `?step=` does (CLA-453) — because a provider OAuth round-trip is a full page
 * load, so any in-memory position would reset on return. Nests under the
 * `dashboard.tsx` layout, so the owner-auth guard runs ahead of this screen.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { type ConnectSectionId, isConnectSectionId } from "~/lib/agent-configure.ts";

/**
 * Validate the `?section=` search param carrying the active configure section.
 * Mirrors the onboarding Connect validator: a known section passes through, and
 * any other value falls back cleanly to an empty search (the page then defaults
 * to Codex).
 *
 * @since 1.0.0
 */
export const validateConfigureSearch = (
  search: Record<string, unknown>,
): { section?: ConnectSectionId } => isConnectSectionId(search["section"]) ? { section: search["section"] } : {};

export const Route = createFileRoute("/clawinstall/dashboard/agents/$agentId_/configure")({
  validateSearch: validateConfigureSearch,
});
